import type { Preset } from '@primeuix/themes/types';
import type { AuraBaseDesignTokens } from "@primeuix/themes/aura/base";

import base from './theme/tokens/basetokens';
import { utility } from './theme/tokens/utility';

import autocomplete from './theme/components/autocomplete';
import avatar from './theme/components/avatar';
import badge from './theme/components/badge';
import button from './theme/components/button';
import card from './theme/components/card';
import carousel from './theme/components/carousel';
import checkbox from './theme/components/checkbox';
import chip from './theme/components/chip';
import confirmdialog from './theme/components/confirmdialog';
import datatable from './theme/components/datatable';
import dataview from './theme/components/dataview';
import datepicker from './theme/components/datepicker';
import dialog from './theme/components/dialog';
import drawer from './theme/components/drawer';
import fieldset from './theme/components/fieldset';
import fileupload from './theme/components/fileupload';
import floatlabel from './theme/components/floatlabel';
import image from './theme/components/image';
import inplace from './theme/components/inplace';
import inputtext from './theme/components/inputtext';
import textarea from './theme/components/textarea';
import menu from './theme/components/menu';
import menubar from './theme/components/menubar';
import message from './theme/components/message';
import multiselect from './theme/components/multiselect';
import overlaybadge from './theme/components/overlaybadge';
import paginator from './theme/components/paginator';
import panel from './theme/components/panel';
import password from './theme/components/password';
import popover from './theme/components/popover';
import progressbar from './theme/components/progressbar';
import progressspinner from './theme/components/progressspinner';
import radiobutton from './theme/components/radiobutton';
import select from './theme/components/select';
import selectbutton from './theme/components/selectbutton';
import skeleton from './theme/components/skeleton';
import slider from './theme/components/slider';
import splitbutton from './theme/components/splitbutton';
import stepper from './theme/components/stepper';
import tabs from './theme/components/tabs';
import tag from './theme/components/tag';
import timeline from './theme/components/timeline';
import toast from './theme/components/toast';
import tooltip from './theme/components/tooltip';
import togglebutton from './theme/components/togglebutton';
import toggleswitch from './theme/components/toggleswitch';
import tree from './theme/components/tree';
import accordion from  './theme/components/accordion';

// Shared component-token layer — identical for all themes (tokens reference
// {primary.*}/{surface.*}/extend tokens, so a palette swap re-themes them).
export const presetComponents = {
    accordion,
    autocomplete,
    avatar,
    badge,
    button,
    card,
    carousel,
    checkbox,
    chip,
    confirmdialog,
    datatable,
    datepicker,
    dataview,
    dialog,
    drawer,
    fieldset,
    fileupload,
    floatlabel,
    image,
    inplace,
    inputtext,
    textarea,
    menu,
    menubar,
    message,
    multiselect,
    overlaybadge,
    paginator,
    panel,
    password,
    popover,
    progressbar,
    progressspinner,
    radiobutton,
    select,
    selectbutton,
    skeleton,
    slider,
    splitbutton,
    stepper,
    tabs,
    tag,
    timeline,
    toast,
    tooltip,
    togglebutton,
    toggleswitch,
    tree
};

export default {
    ...base,
    components: presetComponents,
    extend: utility
} satisfies Preset<AuraBaseDesignTokens>;